import React from 'react';
import { IVerse} from '../model/Interfaces';

export interface IQuizVerseProps{
    Verse: IVerse,
    CssClass?: string,
    onContinue(): void
}

function QuizVerse(props: IQuizVerseProps): React.ReactElement{
    const [screen,setScreen] = React.useState(1);

    const doNextScreen = ():void =>{
        if (screen===1)
            setScreen(2);
        else {
            onClick();
        }
    }

    const onClick = () =>{
        props.onContinue();
    }
    return (
        <div className={props.CssClass} onClick={doNextScreen}>
                <p>{props.Verse.verseref}</p>
            {screen>1 &&
                <p>{props.Verse.verse}</p>
                
            }
            <p className='verse-footer'>Say this verse. When you are done, tap the reference to check yourself.
                Tap it again to continue.</p>
        </div>
    );
}

export default QuizVerse;
